import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  workshopData: [],
  submitData: {},
  eventInfo: null,
  eventGaType: "",
  accessCodeReadyForLocalStorage: ""
};

const eventFormSlice = createSlice({
  name: "eventForm",
  initialState,
  reducers: {
    setWorkshopData: (state, action) => {
      state.workshopData = action.payload;
    },
    setSubmitData: (state, action) => {
      state.submitData = action.payload;
    },
    setEventInfo: (state, action) => {
      state.eventInfo = action.payload;
    },
    setEventGaType: (state, action) => {
      state.eventGaType = action.payload;
    },
    setAccessCode: (state, action) => {
      state.accessCodeReadyForLocalStorage = action.payload;
    },
    resetEventForm: () => initialState,
  },
});

export const {
  setWorkshopData,
  setSubmitData,
  setEventInfo,
  setEventGaType,
  setAccessCode,
  resetEventForm,
} = eventFormSlice.actions;

export default eventFormSlice.reducer;
